/* ===========================================================
   editor/env.js — the editor's line to the rest of the app

   Node views (equations, code, sandboxes) are plain DOM code that the
   editor creates. They read the person's mode and ask the app for
   dialogs and code runners through this object, which the doc page
   fills in. Defaults keep everything safe and inert.
   =========================================================== */

export const env = {
  /** 'casual' | 'dev' */
  mode: () => 'casual',
  /** May sandbox previews run without a click? (your own doc, or you said yes) */
  autoRunPreviews: () => false,
  /** Open the equation editor. Resolves to { latex, display } ('' latex = remove), or null if cancelled. */
  editEquation: async () => null,
  /** Lazily loaded code runner (dev/runner.js). */
  runner: async () => (await import('../dev/dev-runner.js')).runner(),
  /** Short notice to the person (toast). */
  notify: msg => console.info(msg),
  /** Seconds before a running code block is stopped. */
  timeout: () => 10,
};
